import Footer from '../../../components/Footer';
import { HeaderDisplayType, HeaderInteractionType } from '../../../interfaces';
import Header from '../../app/Header';
import StickyHeader from '../../app/StickyHeader';
import { DetailsViewLoader } from '../details-view-loader/details-view-loader';
import { useInputContext } from '../use-input-context';
import { useDetailsParams } from '../utils';
import css from './details-page.module.scss';

export function DetailsPage() {
  const params = useDetailsParams();
  const input = useInputContext();

  if (params === null) {
    throw new Error('DetailsPage must be used within a Route with a path that includes "/details/:type/:id"');
  }

  return (
    <div className={css.container}>
      <DetailsViewLoader
        id={params.id}
        type={params.type}
        orderByProviderId={input.orderByProviderId}
        orderByServiceType={input.orderByServiceType}
        before={<DetailsHeader />}
        after={<Footer />}
      />
    </div>
  );
}

function DetailsHeader() {
  return (
    <>
      <StickyHeader />
      <Header
        displayType={HeaderDisplayType.NoGradient}
        interactionType={HeaderInteractionType.Full}
        hideTitle={true}
      />
    </>
  );
}
